import React from "react";
import { AiOutlineHistory } from "react-icons/ai";

export function HistoryIcon() {
    return (
        <AiOutlineHistory/>
    )
}